import { render, staticRenderFns } from "./PelatihanPetaniCreate.vue?vue&type=template&id=215992fd"
import script from "./PelatihanPetaniCreate.vue?vue&type=script&lang=js"
export * from "./PelatihanPetaniCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports